import styled, { css } from 'styled-components';
import { B as Box } from '../Box/Box-DGi6BERf.js';
import { g as gapMixin, m as mobileGapMixin } from '../theme/style-mixins/gap/index-CO-zSMJ0.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

/* eslint-disable import/prefer-default-export */
const FlexBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40025937__sc-nae1j8-0"
})(["display:flex;border-radius:unset;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  $fullWidth
}) => $fullWidth && css(["width:100%;"]), ({
  $direction
}) => css(["flex-direction:", ";"], $direction), ({
  $alignContent
}) => css(["align-content:", ";"], $alignContent), ({
  $justifyContent
}) => css(["justify-content:", ";"], $justifyContent), ({
  $alignItems
}) => css(["align-items:", ";"], $alignItems), ({
  $wrap
}) => css(["flex-wrap:", ";"], $wrap), ({
  $shrink
}) => css(["flex-shrink:", ";"], $shrink), ({
  $grow
}) => css(["flex-grow:", ";"], $grow), ({
  $basis
}) => css(["flex-basis:", ";"], $basis), gapMixin, isMobile(css(["", ""], mobileGapMixin)));

export { FlexBox as F };
//# sourceMappingURL=Flex.styles-CHWNVWnx.js.map
